import { render, staticRenderFns } from "./BchProductEdit.vue?vue&type=template&id=4e59101e&scoped=true"
import script from "./BchProductEdit.vue?vue&type=script&lang=js"
export * from "./BchProductEdit.vue?vue&type=script&lang=js"
import style0 from "./BchProductEdit.vue?vue&type=style&index=0&id=4e59101e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e59101e",
  null
  
)

export default component.exports